module.exports = __webpack_public_path__ + "static/av-42ab70391f5ca7c6ce49a66438933daa.jpg";